import PropTypes from 'prop-types';
import React from 'react';

import { InputStyled, SuffixWrapper } from 'components/atoms/Input/styled';
import Arrow from 'assets/images/backWhite.svg';
import { InputWrapper } from '../styleds';
import { SelectDropdown, StyledSelectIcon } from '../Select/styled';

const NumberInput = ({ value, style, onClickButton, onChange, name }) => {
  return (
    <InputWrapper
      height={44}
      style={{ display: 'flex', width: 130, ...(style || {}) }}
    >
      <SelectDropdown
        role='presentation'
        onClick={() => onClickButton && onClickButton('decrement')}
        variant='left'
        style={{ cursor: 'pointer', pointerEvents: 'unset' }}
      >
        <StyledSelectIcon src={Arrow} />
      </SelectDropdown>
      <InputStyled
        style={{ padding: 0, textAlign: 'center' }}
        type='number'
        value={value}
        onChange={onChange}
        name={name}
      />
      <SelectDropdown
        role='presentation'
        onClick={() => onClickButton && onClickButton('increment')}
        variant='right'
        style={{ cursor: 'pointer', pointerEvents: 'unset' }}
      >
        <StyledSelectIcon src={Arrow} />
      </SelectDropdown>
    </InputWrapper>
  );
};
NumberInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  onClickButton: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default NumberInput;
